import { createReducer } from './createReducer';
function createStateReducer(reducer) {
    return function (state, action) {
        const slice = state[action.payload.id];
        const newSlice = reducer(slice, action);
        if (slice === newSlice) {
            return state;
        }
        if (newSlice === undefined) {
            const newState = Object.assign({}, state);
            delete newState[action.payload.id];
            return newState;
        }
        return Object.assign(Object.assign({}, state), { [action.payload.id]: newSlice });
    };
}
function createIdAction(type) {
    return (id, payload) => {
        return {
            type,
            payload: {
                id,
                data: payload,
            },
        };
    };
}
function getType(slice, actionKey, namespace) {
    let typeName = actionKey;
    if (slice) {
        typeName = `${slice}/${typeName}`;
    }
    if (namespace) {
        typeName = `${namespace}/${typeName}`;
    }
    return typeName;
}
export const idSliceSymbol = Symbol('idSliceSymbol');
/**
 * A function that accepts an initial state, an object full of reducer
 * functions, and optionally a "slice name", and automatically generates
 * action creators, action types, and selectors that correspond to the
 * reducers and state.
 *
 * The `reducer` argument is passed to `createReducer()`.
 */
export function createIdSlice(options) {
    const { elementName, initialState, namespace = '' } = options;
    const reducers = options.reducers || {};
    const actionKeys = Object.keys(reducers);
    const reducerMap = actionKeys.reduce((map, actionKey) => {
        map[getType(elementName, actionKey, namespace)] = createStateReducer(reducers[actionKey]);
        return map;
    }, {});
    const reducer = createReducer(Object.assign(Object.assign({}, initialState), { [idSliceSymbol]: true }), reducerMap);
    const actionMap = actionKeys.reduce((map, actionType) => {
        const type = getType(elementName, actionType, namespace);
        map[actionType] = createIdAction(type);
        return map;
    }, {});
    const actionTypes = actionKeys.reduce((map, actionType) => {
        map[actionType] = getType(elementName, actionType, namespace);
        return map;
    }, {});
    return {
        elementName,
        reducer,
        actions: actionMap,
        actionTypes,
    };
}
export function createElementIdSlice(options) {
    const { elementName, initialState, update, reducers } = options;
    return createIdSlice({
        namespace: 'birdElement',
        elementName,
        initialState,
        reducers: Object.assign(Object.assign({}, reducers), {
            update: function (state, action) {
                if (!state) {
                    return state;
                }
                let updateState = undefined;
                if (update) {
                    updateState = update(state, action);
                }
                return Object.assign(Object.assign(Object.assign({}, state), updateState), action.payload.data);
            },
            add: function (_state, action) {
                return action.payload.data;
            },
            delete: function (_state, _action) {
                return undefined;
            },
        }),
    });
}
